import script from "./DisclaimerBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DisclaimerBox.vue?vue&type=script&setup=true&lang=js"

import "./DisclaimerBox.vue?vue&type=style&index=0&id=33cc2eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33cc2eaa"]])

export default __exports__